import { Button } from "@/components/ui/button"
import TopbarFilter from "./topbar-filter"
import { ChevronRight } from "lucide-react"
import { useNavigate } from "react-router-dom"

export default function DailyCalendarTopbarActions() {
  const navigate = useNavigate()

  const handleOnClick = () => {
    navigate("/calendar")
  }

  return (
    <div className="flex w-fit items-center gap-4">
      <Button
        className="flex items-center gap-4 bg-transparent text-base text-black"
        onClick={handleOnClick}
      >
        <span>Ir a mi agenda</span>
        <ChevronRight className="!size-5" />
      </Button>

      <TopbarFilter />
    </div>
  )
}
